module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noSubjectMessage":"You have unsaved changes. Do you want to save?","messageWithSubject":"You have changed {subject}. Do you want to save?"},"no":{"noSubjectMessage":"Dine endringer er ikke lagret. Ønsker du å lagre?","messageWithSubject":"Du har endret på {subject}. Ønsker du å lagre?"}}')
  delete Component.options._Ctor
}
